AutofocusDirective.$inject = [];
function AutofocusDirective() {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            _.defer(function () {
                element.focus();
            });
        }
    };
}
angular.module('rinca.core.directives.autofocus', [])
    .directive('rcAutofocus', AutofocusDirective);



//////////////////
// WEBPACK FOOTER
// ./scripts/core/directives/AutofocusDirective.js
// module id = 313
// module chunks = 0